import sortUtils from "@utils/sort.utils";
import i18n from "@plugins/i18n";
import { isEmpty } from "@utils/var.check";
import {
  NOTIFICATION_AUDIENCE,
  NOTIFICATION_SCOPE,
} from "@modules/notification/service/notification.constant";

export default {
  dateFormatInvalid: function (date) {
    let regex = new RegExp(
      "^[0-9]{2} (JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC) [0-9]{4}$",
      "i",
    );
    return !regex.test(date);
  },
  toDateTime: function (selectedDate, selectedTime, selectedAmPm) {
    if (selectedDate && selectedTime) {
      var from = selectedDate.split(" ");
      var months = [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ].indexOf(from[1].toLowerCase());
      let time = selectedTime.split(":");
      if (time.length === 2) {
        let hours = Number(time[0]);
        let minutes = Number(time[1]);
        if (selectedAmPm === "PM" && hours < 12) {
          hours += 12;
        }
        if (selectedAmPm === "AM" && hours === 12) {
          hours -= 12;
        }
        return new Date(from[2], months, from[0], hours, minutes, 0, 0);
      }
    }
    return null;
  },
  sortClassesAndGroupsWithHeader: function (studentGroups) {
    const sortConfig = [{ field: "groupName", asc: true }];
    let sortedGroups = sortUtils.sortObjects(studentGroups, sortConfig);
    let classGroups = [],
      pinnedGroups = [],
      communityGroups = [];
    sortedGroups.forEach((group) => {
      if (group.publicDomain) {
        communityGroups.push({ ...group, disabled: false });
      } else {
        // For non-searchable groups, decide where they should go
        if (group.pinned) {
          pinnedGroups.push({ ...group, disabled: false });
        } else {
          classGroups.push({ ...group, disabled: false });
        }
      }
    });

    let sortedGroupsWithHeader = [];
    if (pinnedGroups.length > 0) {
      sortedGroupsWithHeader.push({
        name: i18n.t("class_dropdown_header_pinned"),
        header: true,
      });
      sortedGroupsWithHeader.push(...pinnedGroups);
    }
    if (classGroups.length > 0) {
      sortedGroupsWithHeader.push({
        name: i18n.t("class_dropdown_header_class_groups"),
        header: true,
      });
      sortedGroupsWithHeader.push(...classGroups);
    }
    if (communityGroups.length > 0) {
      sortedGroupsWithHeader.push({
        name: i18n.t("class_dropdown_header_communities"),
        header: true,
      });
      sortedGroupsWithHeader.push(...communityGroups);
    }

    return sortedGroupsWithHeader;
  },

  /**
   * Function to retrieve the group receiver(s) of an notification.
   * Individual receiver(s) will not be processed.
   *
   * @param notification - The notification.
   * @returns {*} String of the receiver(s) of the notification, delimited by comma.
   */
  getNotificationGroupReceiver: function (notification) {
    let receivers = [];
    const recipients = notification.notificationRecipients;

    for (let recipient of recipients) {
      let audienceType = recipient.audienceType;

      if (audienceType === NOTIFICATION_AUDIENCE.INDIVIDUAL) {
        // we want group receivers, so do nothing for individual receiver
      } else if (audienceType === NOTIFICATION_AUDIENCE.ALL) {
        return i18n.t("announcement_receiver_all_label");
      } else if (audienceType === NOTIFICATION_AUDIENCE.ALL_STUDENTS) {
        return i18n.t("announcement_receiver_all_students_label");
      } else if (audienceType === NOTIFICATION_AUDIENCE.ALL_TEACHERS) {
        return i18n.t("announcement_receiver_all_teachers_label");
      } else if (audienceType === NOTIFICATION_AUDIENCE.FORM_CLASS) {
        // notification to form class:
        // loop to get all formClassCode
        receivers.push(recipient.formClassCode);
      } else {
        // audienceType === null => notification to class/groups:
        // loop to get all groupName
        receivers.push(recipient.groupName);
      }
    }

    return isEmpty(receivers) ? "" : receivers.join(", ");
  },

  getNotificationIndividualReceiver: function (notification) {
    let receivers = [];
    const recipients = notification.notificationRecipients;

    for (let recipient of recipients) {
      let audienceType = recipient.audienceType;

      if (audienceType === NOTIFICATION_AUDIENCE.INDIVIDUAL) {
        receivers.push(recipient.userName);
      }
    }

    return isEmpty(receivers) ? "" : receivers.join(", ");
  },

  getNotificationTeacherIndividuals(notification) {
    let receivers = [];
    const recipients = notification.notificationRecipients;

    for (let recipient of recipients) {
      if (recipient.groupRole === "TEACHER") {
        receivers.push(recipient.userName);
      }
    }

    return isEmpty(receivers) ? "" : receivers.join(", ");
  },

  getNotificationStudentIndividuals(notification) {
    let receivers = [];
    const recipients = notification.notificationRecipients;

    for (let recipient of recipients) {
      if (recipient.groupRole === "STUDENT") {
        receivers.push(recipient.userName);
      }
    }

    return isEmpty(receivers) ? "" : receivers.join(", ");
  },

  getNotificationCreatedBy: function (notification) {
    if (notification.scope === NOTIFICATION_SCOPE.SYSTEM) {
      return i18n.t("announcement_creator_system_admin_label");
    } else {
      return notification.createdByName;
    }
  },
};
